<template>
  <div>
    <div
      class="component-product"
      :style="`flex-direction:${
        showTitleOnTop ? 'column-reverse;' : 'column;'
      } `"
    >
      <img
        :src="imgUrl"
        alt=""
        oncontextmenu="return false"
        :style="`border-radius:${borderRadius}; width:100%;height:${height};`"
      />
      <span>{{ productName }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    productName: {
      type: String,
      default: '产品名称'
    },
    width: {
      type: String,
      default: '2.24rem'
    },
    height: {
      type: String,
      default: '2.24rem'
    },
    margin: {
      type: String,
      default: '0rem'
    },
    borderRadius: {
      type: String,
      default: '0rem'
    },
    showTitleOnTop: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.component-product {
  margin: 0.1rem 0;
  text-align: center;
  cursor: pointer;
}
</style>
